import { cn } from "@tellescope/ui";

export interface ReadOnlyFieldProps {
  id?: string;
  value?: string | null;
  placeholder?: string;
}

export const ReadOnlyField = ({ id, value, placeholder }: ReadOnlyFieldProps) => (
  <p
    id={id}
    className={cn(
      "min-h-9 flex items-center py-2 text-sm font-light whitespace-pre-wrap break-words select-text",
      value ? "text-muted-foreground" : "text-muted-foreground/60 italic"
    )}
  >
    {value || placeholder}
  </p>
);
